export default "__VITE_ASSET__DgGnXKZN__"